"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var jsx_runtime_1 = require("react/jsx-runtime");
var prop_types_1 = __importDefault(require("prop-types"));
var classnames_1 = __importDefault(require("classnames"));
var react_i18next_1 = require("react-i18next");
var ui_1 = require("components/ui");
var local_switcher_module_sass_1 = __importDefault(require("./local-switcher.module.sass"));
var react_1 = __importStar(require("react"));
var LocaleSwitcher = function (_a) {
    var _b, _c;
    var size = _a.size, color = _a.color, im = _a.im, setIm = _a.setIm;
    var i18n = (0, react_i18next_1.useTranslation)().i18n;
    var languages = i18n.languages;
    var _d = (0, react_1.useState)(false), round = _d[0], setRound = _d[1];
    react_1["default"].useEffect(function () {
        var setInitialLanguage = function () { return __awaiter(void 0, void 0, void 0, function () {
            var locale;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        locale = localStorage.getItem('locale');
                        if (!locale) {
                            locale = navigator === null || navigator === void 0 ? void 0 : navigator.language;
                        }
                        return [4 /*yield*/, i18n.changeLanguage(languages.includes(navigator === null || navigator === void 0 ? void 0 : navigator.language) ? locale : 'en')];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        setInitialLanguage();
    }, []);
    var changeLanguage = function (locale) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, i18n.changeLanguage(locale)];
                case 1:
                    _a.sent();
                    localStorage.setItem("locale", locale);
                    setRound(!round);
                    setIm(!im);
                    return [2 /*return*/];
            }
        });
    }); };
    return ((0, jsx_runtime_1.jsxs)("ul", __assign({ onClick: function () { return changeLanguage(languages[1]); }, className: local_switcher_module_sass_1["default"]["locale-switcher"] }, { children: [(0, jsx_runtime_1.jsx)("li", __assign({ className: (0, classnames_1["default"])(local_switcher_module_sass_1["default"].locale, (_b = {},
                    _b[local_switcher_module_sass_1["default"].active] = languages[0] === i18n.language,
                    _b)) }, { children: (0, jsx_runtime_1.jsx)(ui_1.Text, __assign({ size: size, color: color, transform: "capitalize" }, { children: "RU" })) }), languages[0]), (0, jsx_runtime_1.jsx)("li", __assign({ className: (0, classnames_1["default"])(local_switcher_module_sass_1["default"].locale, (_c = {},
                    _c[local_switcher_module_sass_1["default"].active] = languages[1] === i18n.language,
                    _c)) }, { children: (0, jsx_runtime_1.jsx)(ui_1.Text, __assign({ size: size, color: color, transform: "capitalize" }, { children: "EN" })) }), languages[1]), (0, jsx_runtime_1.jsx)("div", { className: local_switcher_module_sass_1["default"].locround, style: { left: languages[0] === 'en' ? '5%' : '58%' } })] })));
};
LocaleSwitcher.defaultProps = {
    size: "md",
    color: "gray"
};
LocaleSwitcher.propTypes = {
    size: prop_types_1["default"].string,
    color: prop_types_1["default"].string
};
exports["default"] = LocaleSwitcher;
